import { PencilSimpleLine } from '@phosphor-icons/react'
import { Table } from 'antd'
import { useGetHighlightedElem } from 'api/Listings/HighlightedElem'
import Spinner from 'components/Spinner'
import { capitalizeFirstLetter } from 'helper/utility'
import moment from 'moment'
import React, { useEffect, useMemo } from 'react'
import { highlightedElementStore } from 'state/listing/highlightedElementListing'
import { BasicListingType } from 'types/listing/listings'

interface HighlightedElementsProps {
  id: string
}

const HighlightedElementsTable: React.FC<HighlightedElementsProps> = ({
  id,
}) => {
  const { setAddHighlightedElementModal, setHighlightedElementData } =
    highlightedElementStore(store => ({
      setAddHighlightedElementModal: store.setAddHighlightedElementModal,
      setHighlightedElementData: store.setHighlightedElementData,
    }))
  const { data, isLoading, isFetching, refetch } = useGetHighlightedElem()

  const handleEditClick = (data: BasicListingType) => {
    setHighlightedElementData(data)
    setAddHighlightedElementModal(true)
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text: string) => (
        <p className="text-14 w-400">{capitalizeFirstLetter(text)}</p>
      ),
    },
    {
      title: 'Last Updated',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (text: string) => (
        <p className="text-14 w-400">{moment(text).format('DD MMM, YYYY')}</p>
      ),
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
      width: '100px',
      render: (data: BasicListingType) => (
        <div className="flex align-center gap-20px">
          <PencilSimpleLine
            size={20}
            color="#000"
            className="pointer"
            onClick={() => handleEditClick(data)}
          />
        </div>
      ),
    },
  ]

  const tableData = useMemo(() => {
    return (
      data?.map(highlightedElem => ({
        Key: highlightedElem._id,
        name: highlightedElem.name,
        updatedAt: highlightedElem.updatedAt,
        actions: highlightedElem,
      })) || []
    )
  }, [data])

  useEffect(() => {
    refetch()
  }, [id])

  return (
    <>
      <div>
        {isLoading || isFetching ? (
          <div className="w-full h-70vh flex align-center justify-center">
            <Spinner />
          </div>
        ) : (
          <Table
            className="colored_header_table"
            columns={columns}
            dataSource={tableData}
            pagination={false}
          />
        )}
      </div>
    </>
  )
}

export default HighlightedElementsTable
